<template>
    <div>
        <div class="user_right">
            <h1 class="urs_h1">我的收藏</h1>
            <div class="fv_top">
                <a href="user_fav.php?act=list&amp;cat_id=0" class="fv_tli fv_ton">商品</a>
            </div>
            <pc-no-fav v-if="tableData.data == []"></pc-no-fav>
            <div class="gdls" v-else>
                <dl class="gl" v-for="(item,index) in tableData.data" :key="index"  @mouseenter="mouseEnter($event)" @mouseleave="mouseLeave($event)">
                    <dt>
                        <router-link :to="{path:'/detail', query:{id:item.id}}" target="_blank">
                            <img :src="item.piclink" width="270" height="270" class="sbm" alt="">
                        </router-link>
                    </dt>
                    <!-- <dd class="simg">
                        <img src="https://s.cccgx.com/t/26x26/images/qu/10631/gallery/20210624034435_93941.jpg" width="26" height="26" class="ss_m">
                    </dd> -->
                    <dd>
                        <router-link :to="{path:'/detail', query:{id:item.id}}" target="_blank" class="gna pt10">
                            {{item.title}}
                        </router-link>
                        <router-link :to="{path:'/detail', query:{id:item.id}}" target="_blank" class="pt_g mt5">
                            <em class="p_tag">{{item.sub_title}}</em>
                        </router-link>
                    </dd>
                    <dd class="gp_d">
                        <i class="rmb left">¥</i>
                        <b class="xj left">{{item.price}}</b>
                        <em class="cs_o">已售{{item.sale}}件</em>
                    </dd>
                    <dd class="pt5">
                        <em class="i_hot">热销</em>
                        <!-- <em class="i_video">视频</em> -->
                        <i class="i_by">包邮</i>
                    </dd>
                </dl>
            </div>
            <div class="page" id="pager">
                <el-pagination :page-sizes="[9,18,27,36]" :page-size="tableFrom.limit" :current-page="tableFrom.page" layout="total, sizes, prev, pager, next, jumper" :total="tableData.total" @size-change="handleSizeChange" @current-change="pageChange" />
            </div>
        </div>
    </div>
</template>

<script>
import Pc_no_fav from "./no_fav.vue"
export default {
    components:{
        "pc-no-fav" : Pc_no_fav
    },
    data(){
        return{
            list:[],
            count:"",
            tableData: {
                data: [],
                total: 0,
            },
            listLoading: true,
            LogLoading: false,
            dialogVisible: false,

            tableFrom: {
                page: 1,
                page_size: 9,
                id:JSON.parse(window.localStorage.getItem("user")).id ? JSON.parse(window.localStorage.getItem("user")).id : "",
            },
        }
    },
    mounted(){
        this.getList(1);
        this.getFav(JSON.parse(window.localStorage.getItem("user")).id);
    },
    methods:{
        getFav(id){
            var params = {};
            params.id = id || "";
            this.$api.getShop.getFav(params).then(res=>{
                if(res.code == 200){
                    this.tableData.data = res.result.collect;
                    this.tableData.total = res.result.counts;  // 总条目数
                    this.tableData.page = res.result.page;
                    this.tableData.page_size = res.result.pageSize;
                    this.listLoading = false;
                }
            })
        },
        //列表
        getList(num) {
            this.listLoading = true;
            this.tableFrom.page = num ? num : this.tableFrom.page;
            this.$api.getShop.getFav(this.tableFrom).then((res) => {
                if (res.code == 200) {
                    this.tableData.data = res.result.collect;
                    this.tableData.total = res.result.counts;  // 总条目数
                    this.tableData.page = res.result.page;
                    this.tableData.page_size = res.result.pageSize;
                    this.tableData.id = JSON.parse(window.localStorage.getItem("user")).id;
                    this.listLoading = false;
                }
            }).catch((res) => {
                this.$message.error(res.message);
                this.listLoading = false;
            });
        },
        pageChange(page) {
            this.tableFrom.page = page;
            this.getList('');
        },
        handleSizeChange(val) {
            this.tableFrom.limit = val;
            this.getList('');
        },
        //   鼠标移入
        mouseEnter($event){
            $event.currentTarget.className="gl hov";
        },
        //   鼠标移除
        mouseLeave($event){
            $event.currentTarget.className="gl";
        },
    }
}
</script>

<style scoped>
@import url('../../assets/css/user.css');
</style>


// WEBPACK FOOTER //
// src/components/fav/Index.vue